/**
 * Per-line delivery tags on cart items (drawer + cart page).
 * Replaces full-width yellow shipment bars with compact tags beside vendor name.
 */
(function () {
  const EXPRESS = () => globalThis.SkippDeliveryClassification?.EXPRESS || 'EXPRESS';

  let lastPayload = null;
  let paintRaf = 0;

  function shortLineMessage(row) {
    const deliveryType = row.deliveryType;
    const storeStatus = row.storeStatus;
    const etaMinutes = row.etaMinutes;

    if (deliveryType === EXPRESS()) {
      if (storeStatus === 'CLOSED') {
        return { text: 'Schedule', variant: 'schedule' };
      }
      const floor = globalThis.SkippDeliveryEtaCalculation?.MIN_ETA_MINUTES ?? 15;
      const fallbackMins = Math.max(
        floor,
        globalThis.SkippDeliveryEtaCalculation?.FALLBACK_EXPRESS_MINUTES ?? 45
      );
      const n =
        etaMinutes != null ? Math.max(floor, Math.ceil(Number(etaMinutes))) : null;
      const mins = n != null ? n : fallbackMins;
      return { text: mins < 60 ? `${mins} min` : '1–2 hrs', variant: 'express' };
    }

    return { text: 'Tomorrow', variant: 'next' };
  }

  function hideGroupBanners() {
    document.querySelectorAll('[data-delivery-group-skipp-wrap]').forEach((wrap) => {
      wrap.hidden = true;
      wrap.setAttribute('aria-hidden', 'true');
    });
  }

  function paintPerLineTags(payload) {
    if (!payload || typeof document === 'undefined') return;

    hideGroupBanners();

    const rows = payload.cartWithStoreStatus;
    if (!Array.isArray(rows) || rows.length === 0) {
      document.querySelectorAll('[data-cart-line-delivery-tag]').forEach((tag) => {
        tag.hidden = true;
      });
      return;
    }

    const rowsByKey = {};
    rows.forEach((r) => {
      if (r.key) rowsByKey[r.key] = r;
    });

    document.querySelectorAll('tr.cart-item[data-cart-line-key]').forEach((tr) => {
      const key = tr.getAttribute('data-cart-line-key');
      const tag = tr.querySelector('[data-cart-line-delivery-tag]');
      const textEl = tag?.querySelector('.cart-item__delivery-tag-text');
      if (!tag || !textEl) return;

      const row = key ? rowsByKey[key] : null;
      if (!row) {
        tag.hidden = true;
        return;
      }

      const { text, variant } = shortLineMessage(row);
      if (!text) {
        tag.hidden = true;
        return;
      }

      textEl.textContent = text;
      tag.hidden = false;
      tag.classList.remove(
        'cart-item__delivery-tag--express',
        'cart-item__delivery-tag--schedule',
        'cart-item__delivery-tag--next'
      );
      tag.classList.add(`cart-item__delivery-tag--${variant || 'next'}`);
      tag.setAttribute('aria-label', `Delivery: ${text}`);
    });
  }

  function schedulePaint() {
    if (!lastPayload || typeof document === 'undefined') return;
    if (paintRaf) cancelAnimationFrame(paintRaf);
    paintRaf = requestAnimationFrame(() => {
      paintRaf = 0;
      paintPerLineTags(lastPayload);
    });
  }

  document.addEventListener('skipp:delivery-pipeline-complete', (e) => {
    lastPayload = e.detail;
    schedulePaint();
  });

  document.addEventListener('skipp:delivery-groups-updated', () => {
    schedulePaint();
  });
})();
